<template>
  <Form
    ref="phoneReg"
    class="reg"
    :validation-schema="schema"
    v-slot="{ errors }"
    autocomplete="off"
  >
    <h2 class="header">注册账号</h2>
    <div class="input-box">
      <div class="input-item">
        <i style="margin-left: 15px" class="iconfont icon-shouji"></i>
        <Field
          v-model="form.phone"
          name="phone"
          type="text"
          class="phone"
          placeholder="请输入手机号码"
        />
      </div>
      <div v-show="errors.phone" class="error-box">
        <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
        {{ errors.phone }}
      </div>
    </div>
    <div class="input-msg">
      <div class="input-item">
        <div class="input-code">
          <i style="margin-left: 15px" class="iconfont icon-anquandengji1"></i>
          <Field
            v-model="form.code"
            name="code"
            class="input"
            type="text"
            placeholder="请输入短信验证码"
          />
          <div class="code-msg">
            <div v-if="msg" @click="getCode" class="get-code">
              <span>获取验证码</span>
            </div>
            <div v-else class="get-code-msg">
              <span>{{ second }}s后重新发送</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="errors.code" class="error-box">
        <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
        {{ errors.code }}
      </div>
    </div>
    <div class="pwd-box">
      <div class="input-item">
        <i style="margin-left: 15px" class="iconfont icon-jiesuo"></i>
        <Field
          v-model="form.password"
          name="password"
          v-if="eye"
          type="password"
          class="input"
          placeholder="请输入密码"
        />
        <Field
          name="password"
          v-else
          type="text"
          v-model="form.password"
          class="input"
          placeholder="请输入密码"
        />
        <div @click="eyeLock" class="lock-pwd">
          <i
            v-if="eye"
            style="
              margin-right: 15px;
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
            class="iconfont icon-biyanjing"
          ></i>
          <i
            v-else
            style="
              margin-right: 15px;
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
            class="iconfont icon-yanjing"
          ></i>
        </div>
      </div>
      <div v-show="errors.password" class="error-box">
        <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
        {{ errors.password }}
      </div>
    </div>
    <div class="pwd-box">
      <div class="input-item">
        <i style="margin-left: 15px" class="iconfont icon-jiesuo"></i>
        <Field
          v-model="form.rePassword"
          name="rePassword"
          v-if="reEye"
          type="password"
          class="input"
          placeholder="请再次输入密码"
        />
        <Field
          name="rePassword"
          v-else
          type="text"
          v-model="form.rePassword"
          class="input"
          placeholder="请再次输入密码"
        />
        <div @click="reEyeLock" class="lock-pwd">
          <i
            v-if="reEye"
            style="
              margin-right: 15px;
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
            class="iconfont icon-biyanjing"
          ></i>
          <i
            v-else
            style="
              margin-right: 15px;
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
            class="iconfont icon-yanjing"
          ></i>
        </div>
      </div>
      <div v-show="errors.rePassword" class="error-box">
        <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
        {{ errors.rePassword }}
      </div>
    </div>
    <div class="reg-box">
      <div class="regi">
        <el-button @click="register" size="large" type="primary"
          >立即注册</el-button
        >
      </div>
      <div @click="toLogin()" class="go-login">
        已有账号？<span>去登陆</span>
      </div>
    </div>
  </Form>
</template>

<script>
import { useIntervalFn } from "@vueuse/core";
import { ElMessage } from "element-plus";
import { Form, Field } from "vee-validate";
import loginSchema from "@/utils/login-validate";
import { sendPhoneCode, useRegister } from "@/api/user";
import { ref, reactive, onMounted, onUnmounted } from "vue";
export default {
  components: { Form, Field },
  props: {
    checked: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const phoneReg = ref(null);
    const msg = ref(true);
    //密码点击显示隐藏
    const eye = ref(true);
    const reEye = ref(true);
    const second = ref(0);
    //表单数据对象
    const form = reactive({
      password: null,
      rePassword: null,
      phone: null,
      code: null,
    });
    //获取验证码
    const { pause, resume } = useIntervalFn(
      () => {
        second.value--;
        if (second.value <= 0) {
          pause();
          msg.value = true;
        }
      },
      1000,
      false
    );
    const getCode = async () => {
      const valid = loginSchema.phone(form.phone);
      if (valid === true) {
        try {
          //验证通过发送短信验证码，弹出短信发送成功提示，开启倒计时
          //发送短信验证码
          const code = await sendPhoneCode(form.phone);
          //后台返回消息，提示验证码发送成功
          /* if (code) {
          ElMessage({
            message: "验证码发送成功",
            type: "success",
          });
        } */
          ElMessage({
            message: code.msg,
            type: "success",
          });
          /* if (code.status == 200) {
            ElMessage({
              message: code.msg,
              type: "success",
            });
          } */
          second.value = 60;
          resume();
          msg.value = false;
        } catch (error) {
          console.log(error);
        }
      } else {
        //验证失败 显示错误信息 setFiekdError(字段，错误信息)
        phoneReg.value.setFieldError("phone", valid);
      }
    };
    const eyeLock = () => {
      eye.value = !eye.value;
    };
    const reEyeLock = () => {
      reEye.value = !reEye.value;
    };
    //校验规则
    const schema = {
      phone: loginSchema.phoneApi,
      code: loginSchema.code,
      password: loginSchema.password,
      rePassword: loginSchema.rePassword,
    };
    //点击前往登录页面
    const toLogin = () => {
      form.password = null;
      form.rePassword = null;
      form.phone = null;
      form.code = null;
      phoneReg.value.resetForm();
      emit("goLogin");
    };
    //点击注册按钮
    const register = async () => {
      if (!props.checked) {
        ElMessage({
          message: "请勾选用户协议及隐私政策",
          type: "error",
        });
      } else {
        const valid = await phoneReg.value.validate();
        if (valid) {
          let { phone, code, password } = form;
          useRegister({ phone, code, password })
            .then((data) => {
              //如果注册成功，提示消息注册成功
              if (data.code == 200) {
                ElMessage({
                  message: data.msg,
                  type: "success",
                });
              }
              //前往登录
              emit("goLogin");
            })
            .catch((error) => {
              ElMessage({
                message: error.message,
                type: "error",
              });
            });
        }
      }
    };
    onUnmounted(() => {
      /* 这里为清除之前的倒计时函数
      if (intervalId) {
        clearInterval(intervalId);
      } */
      pause();
    });
    return {
      form,
      phoneReg,
      msg,
      getCode,
      eyeLock,
      eye,
      reEye,
      schema,
      second,
      toLogin,
      reEyeLock,
      register,
    };
  },
};
</script>

<style lang="less" scoped>
.header {
  text-align: center;
}
.input-box {
  width: 360px;
  height: 75px;
  .input-item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 358px;
    height: 50px;
    opacity: 1;
    background-color: #f6f7f9;
    border-radius: 25px;
    outline: none;
    border: none;
    .phone {
      box-sizing: border-box;
      color: #333;
      padding: 0 15px 0;
      width: 356px;
      height: 47px;
      opacity: 1;
      font-size: 14px;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      border: none;
    }
  }
  .error-box {
    height: 24px;
    color: red;
  }
}
.input-msg {
  width: 365px;
  height: 75px;
  .input-item {
    /* display: flex;
      align-items: center; */
    //margin-bottom: 24px;
    box-sizing: border-box;
    width: 230px;
    height: 50px;
    opacity: 1;
    background-color: #f6f7f9;
    border-radius: 25px;
    outline: none;
    border: none;
    position: relative;
    .input-code {
      display: flex;
      align-items: center;
      .input {
        box-sizing: border-box;
        color: #333;
        padding: 0 8px;
        width: 230px;
        height: 48px;
        opacity: 1;
        font-size: 14px;
        background-color: #f6f7f9;
        border-radius: 25px;
        outline: none;
        border: none;
      }
    }
  }
  .error-box {
    height: 24px;
    color: red;
  }
  .code-msg {
    padding-left: 45px;
    .get-code {
      color: #bfbfbf;
      box-sizing: border-box;
      width: 110px;
      height: 50px;
      border-radius: 25px;
      background-color: #409eff;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      color: #fff;
      cursor: pointer;
      border: none;
      font-size: 14px;
    }
    .get-code-msg {
      text-align: center;
      justify-content: center;
      align-items: center;
      color: #bfbfbf;
      box-sizing: border-box;
      width: 110px;
      height: 50px;
      border-radius: 25px;
      background-color: #f6f7f9;
      display: flex;
      color: #999;
      border: none;
      font-size: 14px;
      cursor: not-allowed;
    }
  }
}
.pwd-box {
  width: 360px;
  height: 75px;
  .input-item {
    display: flex;
    align-items: center;
    //margin-bottom: 24px;
    box-sizing: border-box;
    width: 358px;
    height: 50px;
    opacity: 1;
    background-color: #f6f7f9;
    border-radius: 25px;
    outline: none;
    .input {
      box-sizing: border-box;
      color: #333;
      padding: 0 8px;
      width: 356px;
      height: 48px;
      opacity: 1;
      font-size: 14px;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      border: none;
    }
  }
  .error-box {
    height: 24px;
    color: red;
  }
}
.reg-box {
  display: flex;
  align-items: center;
  .regi {
    margin-left: 120px;
    margin-right: 20px;
  }
  .go-login {
    cursor: pointer;
    span {
      color: @shColor;
    }
  }
}
</style>
